import { EntityType, GenerateFormFieldDataModel } from "src/app/model";

export interface EntityListPayloadModel {
  status: boolean;
  searchKey: string;
  sortBy: {
    [s: string]: 'asc' | 'desc';
  };
  filterBy: GenerateFormFieldDataModel[];
  from: string;
  to: string;
  siteId: string;
  type: EntityType;
  category: string;
  entityIds: string[];
  searchValue: string;
  searchFields: string[];
  domain: string;
  operationalStatusFilter: string[],
  alertsFilter: string[];
  entityCategory ?: string;
  limit?: number;
}

export interface EntityIconListPayloadModel {
  siteId: string;
  entityId: string[];
  entityCategory: string;
  from: string;
  to: string;
}

export interface AggregateCategoryResponse { 
  category: string, 
  entityCount: string, 
  totalEnginehours: number, 
  totalDistance: number,
  totalDistanceTrimmed : number,
  totalEnginehoursTrimmed: number
}
export interface AggregateEntityResponse {
  entityCount: number, 
  totalEnginehours: number, 
  totalDistance: number,
  totalDistanceTrimmed : number,
  totalEnginehoursTrimmed: number
}

export interface AggregatePayload {
  entityIds: string[],
  groupBy:string ,
  siteId?: string,
  from: string,
  to: string,
  searchKey?: string,
  excludeFromFieldInFilters ?: boolean
}